import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "table-cell-content"
}

import { MoveWareHouseHeaderKey, TableContentProperty } from '../../interface/tableContentHeaders';
import TableCell from '../TableCell.vue';
import { TableContentItem } from '../../interface/tableContentItems';
import { i18n } from '@/i18n';
import RegisterUnmanagedBusinessButton from './RegisterUnmanagedBusinessButton.vue';
import { MoveWarehouseTableContentViewModel } from './moveWarehouseTableContentViewModel';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'moveWarehouseTableCell',
  props: {
    header: {},
    moveWarehouseHeaderKey: {},
    item: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    isEditing: { type: Boolean },
    isBold: { type: Boolean },
    isChecked: { type: Boolean },
    isCheckedBusinessId: { type: Boolean }
  },
  emits: ["onClickNarrow"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

// props
const props = __props;

// emits
const emits = __emit;

const moveWarehouseTableContentViewModel = new MoveWarehouseTableContentViewModel();
const textAlign = computed(() => {
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCell, {
    class: _normalizeClass([[_unref(moveWarehouseTableContentViewModel).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : ''], "table-cell base-table__body--fixed"]),
    style: _normalizeStyle({
      left: _unref(moveWarehouseTableContentViewModel).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
    "text-align": textAlign.value,
    "table-content-property": _ctx.header,
    "tool-tip-value": _unref(moveWarehouseTableContentViewModel).displayOrderItem(_ctx.moveWarehouseHeaderKey, _ctx.item),
    "is-highlighted": props.isChecked || props.isCheckedBusinessId
  }, {
    default: _withCtx(() => [
      (_ctx.moveWarehouseHeaderKey === 'differenceAmount')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["table-cell-content", {
          'differenceAmount--positive': _ctx.item.differenceAmount >= 0,
          'differenceAmount--negative': _ctx.item.differenceAmount < 0,
        }])
          }, _toDisplayString(_unref(moveWarehouseTableContentViewModel).displayOrderItem(_ctx.moveWarehouseHeaderKey, _ctx.item)), 3))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(moveWarehouseTableContentViewModel).displayOrderItem(_ctx.moveWarehouseHeaderKey, _ctx.item)), 1))
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "text-align", "table-content-property", "tool-tip-value", "is-highlighted"]))
}
}

})